/*
 * Normcore app bootstrap — Phase A1. Picks the gateway every Normcore screen reads through (blueprint, boundary rule:
 * "no screen may invent data outside fixture or gateway"). In A1 that is the deterministic mock; Phase B (locked) swaps in
 * the production adapter here and nowhere else. `?nc-scenario=<name>` (success, loading, empty, error scenarios of the
 * mock) forces a state for review and tests; The try-on render always uses the real backend. No network.
 * Favorites and saved looks are kept per user in localStorage (D-4, Javi 2026-10-23) through the mock's favoritesStore
 * adapter; the user's real database replaces it in Phase B. Storage that is blocked or full falls back to memory.
 * Brands (F-2): when the page prints the store's brand collections (`script[data-nc-store-brands]`) they are handed to the mock as
 * `storeBrands`, so the Hub and the Branding Corner show the real brands.
 * Products (A1): every `script[data-nc-store-products]` (snippets/nc-store-products.liquid) is read, concatenated and deduplicated by id and
 * handed over as `storeProducts`; the ids of the scripts marked `data-nc-search-results` (the Buscador's real result set, in order) are
 * handed over as `searchResults`, which makes the gateway's searchProducts answer with them instead of the mock catalogue.
 */
(function () {
  if (typeof window === 'undefined' || window.NcApp) return;
  var gateway = null;

  function scenarioFromUrl() {
    try {
      var name = new URLSearchParams(window.location.search).get('nc-scenario');
      var mock = window.NcGatewayMock;
      return name && mock && (mock.SCENARIOS.indexOf(name) >= 0 || (mock.EXTRA_SCENARIOS || []).indexOf(name) >= 0) ? name : 'success';
    } catch (e) {
      return 'success';
    }
  }

  function paramFromUrl(name) {
    try { return new URLSearchParams(window.location.search).get(name); } catch (e) { return null; }
  }

  // D-ESPEJO review states (A1 only): ?nc-mirror=display:store-1,withdrawn:store-2 marks mirror products as display-only or withdrawn
  function mirrorFromUrl() {
    var out = { displayOnly: [], withdrawn: [] };
    try {
      var raw = new URLSearchParams(window.location.search).get('nc-mirror') || '';
      raw.split(',').forEach(function (part) {
        var kv = part.split(':');
        if (kv[0] === 'display' && kv[1]) out.displayOnly.push(kv[1]);
        if (kv[0] === 'withdrawn' && kv[1]) out.withdrawn.push(kv[1]);
      });
    } catch (e) { /* no review state */ }
    return out.displayOnly.length || out.withdrawn.length ? out : undefined;
  }

  var FAVORITES_KEY = 'nc-mock-favorites:';
  var favoritesStore = {
    load: function (userId) {
      try { var raw = window.localStorage.getItem(FAVORITES_KEY + userId); return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
    },
    save: function (userId, state) {
      try { window.localStorage.setItem(FAVORITES_KEY + userId, JSON.stringify(state)); } catch (e) { /* memory only */ }
    }
  };

  // F-2 (Javi, 2026-10-23): the brands of the store, printed once by snippets/nc-store-brands.liquid. Read when the gateway is created;
  // a page without that script gets the mock's own brands.
  function storeBrandsFromPage() {
    try {
      var el = document.querySelector('script[data-nc-store-brands]');
      var data = el ? JSON.parse(el.textContent) : null;
      return Array.isArray(data) && data.length ? data : null;
    } catch (e) {
      return null;
    }
  }

  // B4: the curated looks of every brand (snippets/nc-store-brand-looks.liquid), for the suggestions of the look sheet on pages without the brands
  function brandLooksFromPage() {
    try {
      var el = document.querySelector('script[data-nc-brand-looks]');
      var data = el ? JSON.parse(el.textContent) : null;
      return Array.isArray(data) && data.length ? data : null;
    } catch (e) {
      return null;
    }
  }

  // A1: the store products printed by snippets/nc-store-products.liquid (search results, collection, product page). Several scripts are
  // concatenated; the first record of an id wins. `searchResults` is null unless a script is marked as the Buscador's result set.
  function storeProductsFromPage() {
    var out = { products: [], searchResults: null };
    var seen = {};
    try {
      Array.prototype.forEach.call(document.querySelectorAll('script[data-nc-store-products]'), function (el) {
        var data = null;
        try { data = JSON.parse(el.textContent); } catch (e) { data = null; }
        if (!Array.isArray(data)) return;
        var ids = [];
        data.forEach(function (rec) {
          if (!rec || typeof rec.id !== 'string') return;
          ids.push(rec.id);
          if (!seen[rec.id]) { seen[rec.id] = true; out.products.push(rec); }
        });
        if (el.hasAttribute('data-nc-search-results')) out.searchResults = (out.searchResults || []).concat(ids);
      });
    } catch (e) { /* no products */ }
    return out;
  }

  // Javi, 2026-10-27: the fitting room always goes through the real try-on backend (App Proxy /apps/normcore-tryon, Gemini). The review
  // query params of the mock (?nc-tryon, ?nc-render, ?nc-quota, ?nc-render-polls) are gone; the mock only serves the rest of the gateway.

  window.NcApp = {
    gateway: function () {
      if (!gateway) {
        var products = storeProductsFromPage();
        gateway = window.NcGatewayMock.create({
          scenario: scenarioFromUrl(), favoritesStore: favoritesStore, storeBrands: storeBrandsFromPage(), brandLooks: brandLooksFromPage(),
          storeProducts: products.products.length ? products.products : undefined, searchResults: products.searchResults || undefined,
          mirror: mirrorFromUrl()
        });
        if (window.NcGatewayTryon) gateway = window.NcGatewayTryon.wrap(gateway);
      }
      return gateway;
    }
  };
})();
